import { Alert, Flex, Stack, useMantineTheme } from '@mantine/core';

import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { IconAlertTriangle } from '@tabler/icons-react';

export function RestrictedDomain() {
  const theme = useMantineTheme();
  const { t } = useTranslation('auth');

  return (
    <Alert bg={theme.colors.yellow[1]} color="dark" radius="md" mt={-theme.other.spacing._8}>
      <Flex gap={theme.other.spacing._8} justify="center" align="center">
        <IconAlertTriangle size={32} color={theme.colors.gray2[6]} />
        <Stack spacing={theme.other.spacing._2} ml={theme.other.spacing._8}>
          <Text tag="div">{t('restrictedDomain.copy1')}</Text>
          <Text tag="div">{t('restrictedDomain.copy2')}</Text>
        </Stack>
      </Flex>
    </Alert>
  );
}
